import { Accordion } from '@bridebook/aura';
import { DropdownV2, IDropdownOption } from '@bridebook/ui';
import { IGuestGroup } from '@bridebook/web/lib/inbox/guests/create-message-flow/recipients/use-guests-groups';
import { getSelectedGuestIdsFromGroup } from '@bridebook/web/lib/inbox/guests/guests-helpers';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { SingleGroup } from './single-group';

interface IProps {
  selectedGuestIds: Set<string>;
  handleSelect: (guestId: string, selected: boolean) => void;
  groupingOptions: GuestGroupDropdownOption[];
  groupingOptionIndex: number;
  setGroupingOptionIndex: (index: number) => void;
}

type GuestGroupDropdownOption = IDropdownOption<{ groups: IGuestGroup[] }>;

export const RecipientsGroups = ({
  selectedGuestIds,
  handleSelect,
  groupingOptions,
  groupingOptionIndex,
  setGroupingOptionIndex,
}: IProps) => {
  const { t } = useTranslation('inbox');

  const groupingOption = groupingOptions[groupingOptionIndex];

  const defaultAccordionValue = useMemo(
    () =>
      groupingOption.groups
        .filter((group) => group.teams.flat().length > 0)
        .map((group) => group.id),
    [groupingOption],
  );

  return (
    <div>
      <div className="sticky top-[-8px] z-10 flex flex-col gap-4 py-4">
        <DropdownV2
          fullWidth
          label={t('guests.createMessageFlow.recipients.groupDropdown.label')}
          selected={groupingOption.value}
          onSelect={(option) => setGroupingOptionIndex(groupingOptions.indexOf(option))}
          options={groupingOptions}
          placeholder={t('guests.createMessageFlow.recipients.groupDropdown.placeholder')}
        />
      </div>
      <Accordion type="multiple" defaultValue={defaultAccordionValue} key={groupingOption.value}>
        {groupingOption.groups.map((group, index) => (
          <SingleGroup
            key={index}
            label={group.label}
            group={group}
            onSelect={handleSelect}
            selectedGuestIds={new Set(getSelectedGuestIdsFromGroup(group, selectedGuestIds))}
          />
        ))}
      </Accordion>
    </div>
  );
};
